import { jsPDF } from "jspdf";

// Same logo as receipt
const LOGO_BASE64 = "data:image/jpeg;base64,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";

export const generateFiscalPDF = (fiscal, userName) => {
  try {
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const m = 24;
    let y = 0;

    const violet = [139, 92, 246];
    const dark = [17, 24, 39];
    const mid = [75, 85, 99];
    const light = [156, 163, 175];
    const green = [22, 163, 74];
    const red = [220, 38, 38];

    // Off-white background
    doc.setFillColor(247, 247, 242);
    doc.rect(0, 0, pageWidth, pageHeight, "F");

    // ── LOGO ──
    y = 14;
    try {
      doc.addImage(LOGO_BASE64, "JPEG", m, y - 8, 38, 38);
    } catch (e) {
      console.warn("Logo could not be loaded in fiscal PDF");
    }

    // ── TITLE ──
    doc.setTextColor(...dark);
    doc.setFontSize(20);
    doc.setFont("helvetica", "bold");
    doc.text("Resumen Fiscal", pageWidth - m, y, { align: "right" });

    doc.setTextColor(...violet);
    doc.setFontSize(12);
    doc.text(`Ejercicio ${fiscal.year}`, pageWidth - m, y + 8, { align: "right" });

    doc.setTextColor(...light);
    doc.setFontSize(8);
    doc.setFont("helvetica", "normal");
    const today = new Date().toLocaleDateString("es-ES", { day: "2-digit", month: "long", year: "numeric" });
    doc.text(`Generado el ${today}`, pageWidth - m, y + 14, { align: "right" });

    // ── DIVIDER ──
    y = 42;
    doc.setDrawColor(220, 220, 212);
    doc.setLineWidth(0.3);
    doc.line(m, y, pageWidth - m, y);
    y += 12;

    // ── HELPER: heading ──
    const heading = (title, yPos) => {
      doc.setTextColor(...violet);
      doc.setFontSize(8);
      doc.setFont("helvetica", "bold");
      doc.text(title.toUpperCase(), m, yPos);
      return yPos + 8;
    };

    // ── HELPER: label + value ──
    const field = (label, value, yPos) => {
      doc.setTextColor(...light);
      doc.setFontSize(7.5);
      doc.setFont("helvetica", "normal");
      doc.text(label.toUpperCase(), m, yPos);
      doc.setTextColor(...dark);
      doc.setFontSize(10);
      doc.setFont("helvetica", "normal");
      doc.text(value || "\u2014", m, yPos + 5);
      return yPos + 14;
    };

    // ── DATOS DEL CONTRIBUYENTE ──
    y = heading("Datos del contribuyente", y);
    y = field("Nombre", userName || "Propietario", y);

    // ── TIPOS APLICADOS ──
    y = heading("Tipos aplicados", y);

    doc.setTextColor(...light);
    doc.setFontSize(7.5);
    doc.setFont("helvetica", "normal");
    doc.text("COMISI\u00d3N PLAZAFY", m, y);
    doc.text("IVA", m + 55, y);
    doc.text("RETENCI\u00d3N IRPF", m + 95, y);
    doc.setTextColor(...dark);
    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    doc.text(`${(fiscal.commission_rate * 100)}%`, m, y + 5);
    doc.text(`${(fiscal.iva_rate * 100)}%`, m + 55, y + 5);
    doc.text(`${(fiscal.irpf_rate * 100)}%`, m + 95, y + 5);
    y += 18;

    // divider
    doc.setDrawColor(220, 220, 212);
    doc.setLineWidth(0.2);
    doc.line(m, y, pageWidth - m, y);
    y += 10;

    // ── DESGLOSE TRIMESTRAL ──
    y = heading("Desglose trimestral", y);

    // Table header
    const cols = [m, m + 28, m + 52, m + 78, m + 104, m + 128, m + 150];
    const colLabels = ["", "Bruto", "Comisi\u00f3n", "Base Imp.", "IVA", "IRPF", "Neto"];

    doc.setTextColor(...light);
    doc.setFontSize(7);
    doc.setFont("helvetica", "normal");
    colLabels.forEach((label, i) => {
      doc.text(label, cols[i], y);
    });
    y += 4;

    // thin line
    doc.setDrawColor(220, 220, 212);
    doc.setLineWidth(0.15);
    doc.line(m, y, pageWidth - m, y);
    y += 6;

    // Quarterly rows
    fiscal.quarters.forEach((q) => {
      // Quarter label
      doc.setTextColor(...dark);
      doc.setFontSize(9);
      doc.setFont("helvetica", "bold");
      doc.text(q.label, cols[0], y);

      doc.setFont("helvetica", "normal");
      doc.setFontSize(8.5);

      // Bruto
      doc.setTextColor(...dark);
      doc.text(`${q.gross.toFixed(2)} \u20ac`, cols[1], y);

      // Comision
      doc.setTextColor(...mid);
      doc.text(`-${q.commission.toFixed(2)} \u20ac`, cols[2], y);

      // Base
      doc.setTextColor(...dark);
      doc.text(`${q.base.toFixed(2)} \u20ac`, cols[3], y);

      // IVA
      doc.setTextColor(...green);
      doc.text(`+${q.iva.toFixed(2)} \u20ac`, cols[4], y);

      // IRPF
      doc.setTextColor(...red);
      doc.text(`-${q.irpf.toFixed(2)} \u20ac`, cols[5], y);

      // Neto
      doc.setTextColor(...violet);
      doc.setFont("helvetica", "bold");
      doc.text(`${q.net.toFixed(2)} \u20ac`, cols[6], y);

      y += 4;
      // Row separator
      doc.setDrawColor(240, 240, 235);
      doc.setLineWidth(0.1);
      doc.line(m, y, pageWidth - m, y);
      y += 8;
    });

    // ── TOTAL ANUAL ──
    doc.setDrawColor(...violet);
    doc.setLineWidth(0.5);
    doc.line(m, y - 4, pageWidth - m, y - 4);
    y += 4;

    const a = fiscal.annual;

    doc.setTextColor(...dark);
    doc.setFontSize(9);
    doc.setFont("helvetica", "bold");
    doc.text(`Total ${fiscal.year}`, cols[0], y);

    doc.setFontSize(8.5);
    doc.text(`${a.gross.toFixed(2)} \u20ac`, cols[1], y);

    doc.setTextColor(...mid);
    doc.setFont("helvetica", "bold");
    doc.text(`-${a.commission.toFixed(2)} \u20ac`, cols[2], y);

    doc.setTextColor(...dark);
    doc.text(`${a.base.toFixed(2)} \u20ac`, cols[3], y);

    doc.setTextColor(...green);
    doc.text(`+${a.iva.toFixed(2)} \u20ac`, cols[4], y);

    doc.setTextColor(...red);
    doc.text(`-${a.irpf.toFixed(2)} \u20ac`, cols[5], y);

    doc.setTextColor(...violet);
    doc.setFontSize(9);
    doc.text(`${a.net.toFixed(2)} \u20ac`, cols[6], y);

    y += 16;

    // ── RESUMEN GRANDES CIFRAS ──
    doc.setDrawColor(220, 220, 212);
    doc.setLineWidth(0.2);
    doc.line(m, y, pageWidth - m, y);
    y += 10;

    y = heading("Resumen anual", y);

    // Big numbers - 3 columns
    const c1 = m;
    const c2 = m + 56;
    const c3 = m + 112;

    // Ingresos brutos
    doc.setTextColor(...light);
    doc.setFontSize(7.5);
    doc.setFont("helvetica", "normal");
    doc.text("INGRESOS BRUTOS", c1, y);
    doc.text("BASE IMPONIBLE", c2, y);
    doc.text("NETO A PERCIBIR", c3, y);

    doc.setFontSize(16);
    doc.setFont("helvetica", "bold");

    doc.setTextColor(...dark);
    doc.text(`${a.gross.toFixed(2)} \u20ac`, c1, y + 8);

    doc.setTextColor(...dark);
    doc.text(`${a.base.toFixed(2)} \u20ac`, c2, y + 8);

    doc.setTextColor(...violet);
    doc.text(`${a.net.toFixed(2)} \u20ac`, c3, y + 8);

    y += 20;

    // Second row
    doc.setTextColor(...light);
    doc.setFontSize(7.5);
    doc.setFont("helvetica", "normal");
    doc.text("COMISI\u00d3N PLAZAFY", c1, y);
    doc.text("IVA REPERCUTIDO", c2, y);
    doc.text("RETENCI\u00d3N IRPF", c3, y);

    doc.setFontSize(14);
    doc.setFont("helvetica", "bold");

    doc.setTextColor(...mid);
    doc.text(`-${a.commission.toFixed(2)} \u20ac`, c1, y + 8);

    doc.setTextColor(...green);
    doc.text(`+${a.iva.toFixed(2)} \u20ac`, c2, y + 8);

    doc.setTextColor(...red);
    doc.text(`-${a.irpf.toFixed(2)} \u20ac`, c3, y + 8);

    y += 18;

    // Reservas totales
    doc.setTextColor(...light);
    doc.setFontSize(7.5);
    doc.setFont("helvetica", "normal");
    doc.text("RESERVAS TOTALES", c1, y);

    doc.setTextColor(...dark);
    doc.setFontSize(14);
    doc.setFont("helvetica", "bold");
    doc.text(`${a.bookings_count}`, c1, y + 8);

    // ── FOOTER ──
    y = pageHeight - 30;
    doc.setDrawColor(220, 220, 212);
    doc.setLineWidth(0.2);
    doc.line(m, y - 6, pageWidth - m, y - 6);

    doc.setTextColor(...light);
    doc.setFontSize(7);
    doc.setFont("helvetica", "normal");
    doc.text("* Datos orientativos. Consulta con tu asesor fiscal para la declaraci\u00f3n definitiva ante la AEAT.", m, y);
    doc.text("hola@plazafy.es", m, y + 6);
    doc.setTextColor(...violet);
    doc.setFont("helvetica", "bold");
    doc.text("www.plazafy.es", pageWidth - m, y + 6, { align: "right" });

    // ── SAVE ──
    doc.save(`Resumen_Fiscal_Plazafy_${fiscal.year}.pdf`);
    return true;
  } catch (error) {
    console.error("Error generating fiscal PDF:", error);
    alert("Error al generar el PDF: " + error.message);
    return null;
  }
};
